<template>
  <BaseModal
    name="modalSmsPresets"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="() => {}"
    @before-open="loadData"
    :scrollable="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('modalSmsPresets')"
      ></button>

      <div class="">
        <div class="tw-app-modal__title">
          {{ dataLang["orders_page_btn_text1"] }}
        </div>

        <div class="tw-mb-[15px]">
          <div class="tw-app-input-type-3-label">Название</div>
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            input-name="sms_presets__name"
            @input="updateValue"
            :value="dataForEmit?.sms_presets__name"
            :name-sign="''"
          />
        </div>

        <div class="tw-mb-[15px]">
          <div class="tw-app-input-type-3-label">Текст</div>
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            input-name="sms_presets__text"
            @input="updateValue"
            :value="dataForEmit?.sms_presets__text"
          />
        </div>

        <div class="tw-text-forText tw-mt-[15px]">
          <b> {{ dataLang["orders-page__table__header_order_text14"] }}: </b>
          {{ smsStat.countSymbols }}
          {{ dataLang["orders-page__modal_sms"] }}
          {{ smsStat.countSms }} SMS
        </div>

        <div class="tw-app-modal__footer">
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            <img
              :src="require(`@/assets/icons/addwhite.svg`)"
              width="13.5"
              height="13.5"
              class="tw-my-[-5px]"
            />
            Добавить
          </button>
          <button @click="acceptDelete" class="tw-app-btn-primary-outline">
            <img
              :src="require(`@/assets/icons/minus-dark.svg`)"
              width="13.5"
              height="13.5"
              class="tw-my-[-5px]"
            />
            Удалить
          </button>
        </div>

        <div class="tw-mt-[15px]">
          <ve-table
            class="rest-style-table"
            style="width: 100%"
            :columns="columns"
            :table-data="tableData"
            :border-x="true"
            :border-y="true"
            row-key-field-name="sms_presets__id"
            ref="mainTable"
            :eventCustomOption="eventCustomOption"
            :checkbox-option="{
              hideSelectAll: true,
              selectedRowChange: selectedRowChange,
            }"
            v-if="!localLoading"
            :clickHighlight="false"
            :cell-style-option="cellStyleOption"
            :rowStyleOption="{
              hoverHighlight: true,
            }"
            :cellSelectionOption="{ enable: false }"
          />
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";
import BidsService from "@/api/BidsService";
import EventBus from "@/event-bus.js";
import OwnersService from "@/api/OwnersService";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable,
  },
  props: {
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
    typeReestr: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      selectLabel: "",
      listOptions: [],
      owner: [],
      localLoading: false,
      tableData: [],
      dataForEmit: {},
      activeSelectRowsMultiple: [],
      smsStat: {
        countSymbols: 0,
        countSms: 0,
      },
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {},
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {},
      },
    };
  },
  methods: {
    loadData() {
      this.localLoading = true;
      GeneralService.get(`/presets/sms`, {
        params: {
          where: JSON.stringify([
            { field: "sms_presets__category_id", value: this.typeReestr },
          ]),
        },
      })
        .then((data) => {
          this.tableData = data.data.data.rows;
          this.localLoading = false;
        })
        .catch((e) => {});
    },
    acceptDelete() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete(`/presets/sms/` + this.activeSelectRowsMultiple)
          .then((data) => {
            this.$toast.success(data.data.message);
            this.localLoading = false;
            this.loadData();
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message);
          });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    beforeClose(event) {
      this.dataForEmit = {};
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      if (data.name == "sms_presets__text") {
        this.updateSmsStat(data.value);
      }
    },
    updateSmsStat(symbols) {
      this.smsStat.countSymbols = symbols.length;
      this.smsStat.countSms = Math.ceil(symbols.length / 70);
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    sendData() {
      if (
        this.dataForEmit?.sms_presets__name &&
        this.dataForEmit?.sms_presets__text
      ) {
        this.localLoading = true;
        GeneralService.editOrCreate(`/presets/sms`, {
          ...this.dataForEmit,
          sms_presets__category_id: this.typeReestr,
        })
          .then((data) => {
            this.loadData();
            this.$toast.success(data.data.message);
            this.dataForEmit = {};
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.success(e.response.data.message);
          });
      } else {
        this.$toast.error("Заполните все поля", { duration: 5000 });
      }
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),

    //     {
    //     "sms_presets__category_id": 2,
    //     "sms_presets__company_id": 2,
    //     "sms_presets__created_at": "2024-01-19 08:36:52",
    //     "sms_presets__id": 6,
    //     "sms_presets__name": "третий",
    //     "sms_presets__text": "Не пользуйтесь нашими услугами",
    //     "sms_presets__updated_at": "2024-01-19 11:36:52"
    // }

    columns() {
      return [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: "5%",
          align: "center",
        },
        {
          field: "sms_presets__name",
          key: "12",
          title: "Название",
          align: "left",
          width: "20%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "sms_presets__text",
          key: "122",
          title: "Текст",
          align: "left",
          width: "75%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
      ];
    },
  },
};
</script>
